/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { customInstance } from "../../axios-instance";
import type { ErrorType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAllPizzaTypes = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/admin/pizza_types/`, method: "GET", signal },
    options,
  );
};

export const getGetAllPizzaTypesQueryKey = () => {
  return [`/api/admin/pizza_types/`] as const;
};

export const getGetAllPizzaTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPizzaTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAllPizzaTypes>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllPizzaTypesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPizzaTypes>>
  > = ({ signal }) => getAllPizzaTypes(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPizzaTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllPizzaTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPizzaTypes>>
>;
export type GetAllPizzaTypesQueryError = ErrorType<unknown>;

export function useGetAllPizzaTypes<
  TData = Awaited<ReturnType<typeof getAllPizzaTypes>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPizzaTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPizzaTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllPizzaTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllPizzaTypes<
  TData = Awaited<ReturnType<typeof getAllPizzaTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPizzaTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPizzaTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllPizzaTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllPizzaTypes<
  TData = Awaited<ReturnType<typeof getAllPizzaTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPizzaTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllPizzaTypes<
  TData = Awaited<ReturnType<typeof getAllPizzaTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPizzaTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllPizzaTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPizzaByType = (
  pizzaTypeId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/admin/pizza_types/${pizzaTypeId}`, method: "GET", signal },
    options,
  );
};

export const getGetPizzaByTypeQueryKey = (pizzaTypeId: string) => {
  return [`/api/admin/pizza_types/${pizzaTypeId}`] as const;
};

export const getGetPizzaByTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPizzaByType>>,
  TError = ErrorType<unknown>,
>(
  pizzaTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaByType>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPizzaByTypeQueryKey(pizzaTypeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPizzaByType>>> = ({
    signal,
  }) => getPizzaByType(pizzaTypeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pizzaTypeId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPizzaByType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPizzaByTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPizzaByType>>
>;
export type GetPizzaByTypeQueryError = ErrorType<unknown>;

export function useGetPizzaByType<
  TData = Awaited<ReturnType<typeof getPizzaByType>>,
  TError = ErrorType<unknown>,
>(
  pizzaTypeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaByType>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaByType>>,
          TError,
          Awaited<ReturnType<typeof getPizzaByType>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPizzaByType<
  TData = Awaited<ReturnType<typeof getPizzaByType>>,
  TError = ErrorType<unknown>,
>(
  pizzaTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaByType>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaByType>>,
          TError,
          Awaited<ReturnType<typeof getPizzaByType>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPizzaByType<
  TData = Awaited<ReturnType<typeof getPizzaByType>>,
  TError = ErrorType<unknown>,
>(
  pizzaTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaByType>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPizzaByType<
  TData = Awaited<ReturnType<typeof getPizzaByType>>,
  TError = ErrorType<unknown>,
>(
  pizzaTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaByType>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPizzaByTypeQueryOptions(pizzaTypeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
